const firebaseConfig = {
    apiKey: "AIzaSyAQn07UXKIDSX7x8RiZBkpeJGbIKS4ydQ0",
    authDomain: "reflectionblog-c3156.firebaseapp.com",
    projectId: "reflectionblog-c3156",
    storageBucket: "reflectionblog-c3156.appspot.com",
    messagingSenderId: "413575259629",
    appId: "1:413575259629:web:07fc3186d3ef42b23973e4",
    measurementId: "G-MNVWLT5HDD"
  };

export default firebaseConfig;
